<div class="sz-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <label>Raktár <select [(ngModel)]="raktar"><option value="">Összes raktár</option><option *ngFor="let r of raktarak" [value]="r.id">{{ r.nev }}</option></select></label>
      <input type="search" [(ngModel)]="kereso" placeholder="Keresés…">
      <label><input type="checkbox" [(ngModel)]="csakVan"> csak ami van</label>
      <label><input type="checkbox" [(ngModel)]="csakHiany"> minimum alatt</label>
      <span class="spacer"></span><span class="halvany">Készletérték ({{ modszerNev || 'értékelés' }}): <b>{{ szam(osszErtek) }} Ft</b> · <a routerLink="/inventario/ertekeles">ELÁBÉ, árrés, feladás</a></span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs sz-racs">
        <thead><tr><th>Cikkszám</th><th>Megnevezés</th><th>Csoport</th><th class="num">Készlet</th><th class="num" *ngIf="!raktar && raktarak.length > 1">Raktáranként</th>
          <th class="num">Min.</th><th class="num">Egységérték</th><th class="num">Érték</th></tr></thead>
        <tbody><tr *ngFor="let c of lathato">
          <td>{{ c.cikkszam }}</td><td><b>{{ c.nev }}</b></td><td>{{ c.csoport }}</td>
          <td class="num" [class.inv-hiany]="c.hiany">{{ szam(menny(c)) }} {{ c.egyseg }}</td>
          <td class="num halvany" *ngIf="!raktar && raktarak.length > 1"><span *ngFor="let r of raktarak">{{ r.kod || r.nev }}: {{ szam(c.raktarankent?.[r.id] || 0) }} </span></td>
          <td class="num">{{ szam(c.min_keszlet) }}</td><td class="num">{{ szam(c.atlagar) }}</td><td class="num">{{ szam(ertek(c)) }}</td>
        </tr></tbody>
      </table>
      <div class="sz-ures" *ngIf="!lathato.length">Nincs készletnyilvántartott cikk – a Cikkek között jelölhető.</div>
    </div>
  </ng-container>
</div>
